import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class FlyoutService {
  appName!: string;
  isResetFlyout = signal<boolean>(true); //true;
  flyoutHeader = signal<string>("");
  flyoutHeaderSignal = signal<string>("Application List");

  constructor() {}

  setFlyoutHeader(header: string): void {
    this.flyoutHeaderSignal.set(header);
  }
  getFlyoutHeader(): string {
    return this.flyoutHeaderSignal();
  }
  resetFlyoutHeader(): void {
    this.flyoutHeaderSignal.set("Application List");
  }
}
